import React, { PropTypes } from 'react';

import staff from '../../state/staff';
import { getPrimaryIdentityIdFromProfileId } from '../ProfilePage/helpers/profile';

import { srOnly } from '../../base-styles/mixins.module.css';
import {
  image,
  largeAvatar,
  largeBadge,
  mediumAvatar,
  mediumBadge,
  smallAvatar,
  smallBadge,
} from './styles.module.css';

// Reduce object of staff to array of primaryIdentityIds
const staffIDs = Object.keys(staff).map(s =>
  getPrimaryIdentityIdFromProfileId(staff[s].permalink.split('/profile/').pop()),
);

/**
 * Avatar presentational component.
 */
const Avatar = ({ className, medium, small, user }) => {
  const isStaff = staffIDs.includes(user.primaryIdentityId);
  const avatarSize = small ? smallAvatar : medium ? mediumAvatar : largeAvatar; // eslint-disable-line
  const badgeSize = small ? smallBadge : medium ? mediumBadge : largeBadge; // eslint-disable-line
  return (
    <div className={[avatarSize, className].join(' ')}>
      <div style={{ backgroundImage: `url(${user.pictureUrl})` }} className={image}>
        {isStaff && <span className={badgeSize} />}
        <span className={srOnly}>{`${user.givenName || ''} ${user.familyName || ''}`}</span>
      </div>
    </div>
  );
};

Avatar.propTypes = {
  className: PropTypes.string,
  medium: PropTypes.bool,
  small: PropTypes.bool,
  user: PropTypes.shape({
    familyName: PropTypes.string,
    givenName: PropTypes.string,
    pictureUrl: PropTypes.string.isRequired,
  }).isRequired,
};

Avatar.defaultProps = {
  className: '',
  medium: false,
  small: false,
};

export default Avatar;



// WEBPACK FOOTER //
// ./app/src/components/Avatar/index.jsx